import CryptoJS from "crypto-js";
//生成随机数
export const showval = () => {
  var num = "";
  for (var i = 0; i < 16; i++) {
    var tmp = Math.ceil(Math.random() * 15); //取出一位十六进制的整数
    if (tmp > 9) {
      //依次判断随机数
      switch (tmp) {
        case 10: //如果随机数等于10，换为a
          num += "a";
          break;
        case 11:
          num += "b"; //如果随机数等于11，换为b
          break;
        case 12:
          num += "c"; //如果随机数等于12，换为c
          break;
        case 13:
          num += "d"; //如果随机数等于13，换为d
          break;
        case 14:
          num += "e"; //如果随机数等于14，换为e
          break;
        case 15:
          num += "f"; //如果随机数等于15，换为f
          break;
      }
    } else {
      num += tmp;
    }
  }
  return num;
};
//加密
export const Encrypt = (word) => {
  const key = CryptoJS.enc.Utf8.parse(getAESkey()); //十六位十六进制数作为密钥
  let encrypted = "";
  if (typeof word == "string") {
    let srcs = CryptoJS.enc.Utf8.parse(word);
    encrypted = CryptoJS.AES.encrypt(srcs, key, {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7,
    });
  } else if (typeof word == "object") {
    //对象格式的转成json字符串
    let data = JSON.stringify(word);
    let srcs = CryptoJS.enc.Utf8.parse(data);
    encrypted = CryptoJS.AES.encrypt(srcs, key, {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7,
    });
  }
  return encrypted.toString();
};
//解密
export const Decrypt = (word) => {
  const key = CryptoJS.enc.Utf8.parse(getAESkey()); //十六位十六进制数作为密钥
  let decrypt = CryptoJS.AES.decrypt(word, key, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7,
  });
  return decrypt.toString(CryptoJS.enc.Utf8);
};

export function getAESkey() {
  return window.sessionStorage.getItem("AESkey");
}

export function editAESkey(value) {
  window.sessionStorage.setItem("AESkey", value);
}
export const publicKey =
  "MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCfCPOCmCcr5xrRjs6IYiGUPccT1DLUUYXRLEcUBmyiE2y9uMOY+PU0awlD++ynfSq6nNeMjMznY2gXn1sQbkxTA9h6pAUU1zHEPDtQlpoA9xGFhivAu7ldKywsCswXjZsfAPSDan2tmJ0HaLHQ3Nhjv5gXcDwZGTDCLu4XYfMiRwIDAQAB";
